module.exports = __webpack_public_path__ + "img/gluten.c094fe05.svg";